import React, { useState } from "react";
import PersonalInfoForm from "../forms/PersonalInfoForm";
import BioForm from "../forms/BioForm";
import SocialForm from "../forms/SocialForm";
import InstitutionDetailsForm from "../forms/InstitutionDetailsForm";
import "../../account/AccountPage.css";
import { formatNigerianPhone } from "../../../utils/formatters";
import BioDisplay from "../../../components/bioDisplay/BioDisplay";
import IdentityVerificationCard from "../../../components/identityVerification/IdentityVerificationCard";

const InstitutionAbout = ({ user, setStatusModal }) => {
  const [editing, setEditing] = useState({
    training: false,
    bio: false,
    admin: false,
    social: false,
    details: false,
  });

  const toggleEdit = (section) => {
    setEditing((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const platformIcons = {
    x: "𝕏",
    instagram: "📸",
    facebook: "📘",
    linkedin: "💼",
  };

  return (
    <>
      <IdentityVerificationCard setStatusModal={setStatusModal} />
      <div className="about-wrapper institution-layout">
      {/* LEFT COLUMN */}
      <div className="left-column">
        {/* TRAINING CENTRE INFO */}
        <div className="account-profile-card">
          <div className="account-profile-header">
            <h3>Training Centre Information</h3>

            {!editing.training && (
              <button
                onClick={() => toggleEdit("training")}
                className="edit-btn"
              >
                ✏️ Edit
              </button>
            )}
          </div>

          {editing.training ? (
            <PersonalInfoForm
              onCancel={() => toggleEdit("training")}
              setStatusModal={setStatusModal}
            />
          ) : (
            <div className="info-grid">
              <div className="info-item">
                <span>Training Centre Name</span>
                <p>{user?.academyName}</p>
              </div>

              <div className="info-item">
                <span>Email</span>
                <p>{user?.email}</p>
              </div>

              <div className="info-item">
                <span>Phone</span>
                <p>{formatNigerianPhone(user?.phone)}</p>
              </div>

              <div className="info-item full">
                <span>Address</span>
                <p>{user?.location?.address}</p>
              </div>
            </div>
          )}
        </div>

        {/* SOCIAL */}
        <div className="account-profile-card">
          <div className="account-profile-header">
            <h3>Social Media</h3>

            {!editing.social && (
              <button onClick={() => toggleEdit("social")} className="edit-btn">
                ✏️ Edit
              </button>
            )}
          </div>

          {editing.social ? (
            <SocialForm
              onCancel={() => toggleEdit("social")}
              setStatusModal={setStatusModal}
            />
          ) : (
            <div className="info-grid">
              <div className="info-item">
                <span>Platform</span>
                <p>
                  {user?.socialMedia?.platform &&
                    platformIcons[user?.socialMedia?.platform]}
                  {user?.socialMedia?.platform || "-"}
                </p>
              </div>

              <div className="info-item">
                <span>Link</span>
                <p>
                  {user?.socialMedia?.link ? (
                    <a
                      href={user.socialMedia.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {user.socialMedia.link}
                    </a>
                  ) : (
                    "-"
                  )}
                </p>
              </div>
            </div>
          )}
        </div>

        {/* TRAINING CENTRE DETAILS — facilities, hours, schedules, age
            groups, accreditations, branches, upcoming programmes, photos */}
        <div className="account-profile-card">
          <div className="account-profile-header">
            <h3>Training Centre Details</h3>

            {!editing.details && (
              <button onClick={() => toggleEdit("details")} className="edit-btn">
                ✏️ Edit
              </button>
            )}
          </div>

          {editing.details ? (
            <InstitutionDetailsForm
              onCancel={() => toggleEdit("details")}
              setStatusModal={setStatusModal}
            />
          ) : (
            <div className="info-grid">
              <div className="info-item full">
                <span>Facilities</span>
                <p>
                  {user?.facilities?.length ? user.facilities.join(", ") : "-"}
                </p>
              </div>

              <div className="info-item full">
                <span>Learner Age Groups</span>
                <p>{user?.ageGroups?.length ? user.ageGroups.join(", ") : "-"}</p>
              </div>

              <div className="info-item full">
                <span>Accreditations / Affiliations</span>
                <p>
                  {user?.accreditations?.length
                    ? user.accreditations.join(", ")
                    : "-"}
                </p>
              </div>

              <div className="info-item full">
                <span>Opening Hours</span>
                <p>
                  {user?.openingHours?.length
                    ? user.openingHours
                        .filter((d) => !d.closed && (d.open || d.close))
                        .map((d) => `${d.day}: ${d.open || "?"}-${d.close || "?"}`)
                        .join(", ") || "Not specified"
                    : "-"}
                </p>
              </div>

              <div className="info-item">
                <span>Class Schedules</span>
                <p>{user?.classSchedules?.length || 0} added</p>
              </div>

              <div className="info-item">
                <span>Branches</span>
                <p>{user?.branches?.length || 0} added</p>
              </div>

              <div className="info-item">
                <span>Upcoming Programmes</span>
                <p>{user?.upcomingProgrammes?.length || 0} added</p>
              </div>

              <div className="info-item">
                <span>Photos</span>
                <p>{user?.photos?.length || 0} uploaded</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* RIGHT COLUMN */}
      <div className="right-column">
        {/* BIO */}
        <div className="account-profile-card">
          <div className="account-profile-header">
            <h3>Bio</h3>

            {!editing.bio && (
              <button onClick={() => toggleEdit("bio")} className="edit-btn">
                ✏️ Edit
              </button>
            )}
          </div>

          {editing.bio ? (
            <BioForm
              onCancel={() => toggleEdit("bio")}
              setStatusModal={setStatusModal}
            />
          ) : (
            <BioDisplay provider={user} />
          )}
        </div>

        {/* ADMIN INFO (READ-ONLY DISPLAY) */}
        <div className="account-profile-card">
          <div className="account-profile-header">
            <h3>Administrator Information</h3>

            {/* 👉 Edit handled inside PersonalInfoForm */}
            <button 
            onClick={() => toggleEdit("training")} 
            className="edit-btn">
              ✏️ Edit
            </button>
          </div>

          <div className="info-grid">
            <div className="info-item">
              <span>First Name</span>
              <p>{user?.adminFirstName}</p>
            </div>

            <div className="info-item">
              <span>Last Name</span>
              <p>{user?.adminLastName}</p>
            </div>

            <div className="info-item">
              <span>Email</span>
              <p>{user?.adminEmail}</p>
            </div>

            <div className="info-item">
              <span>Phone</span>
              <p>{formatNigerianPhone(user?.adminPhone)}</p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};



export default InstitutionAbout;
